webpackJsonp([191319344601756],{

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HTMLContent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HTMLContent = exports.HTMLContent = function HTMLContent(_ref) {
	  var content = _ref.content,
	      className = _ref.className;
	  return _react2.default.createElement('div', { className: className, dangerouslySetInnerHTML: { __html: content } });
	};
	
	var Content = function Content(_ref2) {
	  var content = _ref2.content,
	      className = _ref2.className;
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    content
	  );
	};
	
	Content.propTypes = {
	  content: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	HTMLContent.propTypes = Content.propTypes;
	
	exports.default = Content;

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.contactPageQuery = exports.ContactPageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Content = __webpack_require__(41);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPageTemplate = exports.ContactPageTemplate = function ContactPageTemplate(_ref) {
	  var title = _ref.title,
	      content = _ref.content,
	      contentComponent = _ref.contentComponent;
	
	  var PageContent = contentComponent || _Content2.default;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'section section--gradient' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-10 is-offset-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'title is-size-3 has-text-weight-bold is-bold-light' },
	              title
	            ),
	            _react2.default.createElement(PageContent, { className: 'content', content: content }),
	            _react2.default.createElement(
	              'form',
	              { name: 'contact', 'data-netlify': 'true', 'data-netlify-honeypot': 'input' },
	              _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact' }),
	              _react2.default.createElement(
	                'p',
	                { hidden: true },
	                _react2.default.createElement('input', { name: 'input' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'field' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label' },
	                  'Name'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'control' },
	                  _react2.default.createElement('input', { name: 'name', className: 'input', type: 'text' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'field' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label' },
	                  'Email'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'control' },
	                  _react2.default.createElement('input', { name: 'email', className: 'input', type: 'email' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'field' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'label' },
	                  'Message'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'control' },
	                  _react2.default.createElement('textarea', { name: 'message', className: 'textarea' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'field is-grouped' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'control' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'button is-link' },
	                    'Submit'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}; // Form submission handled by netlify
	// https://www.netlify.com/docs/form-handling/
	
	// TODO make it work better
	// https://www.netlify.com/blog/2017/07/20/how-to-integrate-netlifys-form-handling-in-a-react-app/
	// https://github.com/imorente/gatsby-netlify-form-example/blob/master/src/pages/contact.js
	
	ContactPageTemplate.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  content: _propTypes2.default.string,
	  contentComponent: _propTypes2.default.func
	};
	
	var ContactPage = function ContactPage(_ref2) {
	  var data = _ref2.data;
	  var post = data.markdownRemark;
	
	
	  return _react2.default.createElement(ContactPageTemplate, {
	    contentComponent: _Content.HTMLContent,
	    title: post.frontmatter.title,
	    content: post.html
	  });
	};
	
	ContactPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = ContactPage;
	var contactPageQuery = exports.contactPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-contact-page-js-87ad8fad6edf36802e9a.js